// const text = "What's up, world? 你好世界！ こんにちは世界！สวัสดีชาวโลก";
// const segmenter = new Intl.Segmenter([], { granularity: 'word' });
// const segmentedText = segmenter.segment(text);
// const words = [...segmentedText].filter(s => s.isWordLike).map(s => s.segment);

/* Fonction d'échappement pour éviter l'injection HTML */
function escapeHTML(str) {
    return str.replace(/[&<>"']/g, function (m) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
}

export default function initRedacted() {
    document.querySelectorAll('.redacted').forEach(function (el) {
        // Récupère le texte original et split sur les espaces (1+)
        const text = el.textContent.trim();
        if (text.length === 0) return;

        // Découpe en mots (conserve ponctuation attachée au mot)
        const words = text.split(/\s+/);

        // Remplace l'intérieur par des spans
        el.innerHTML = words.map(function (w) {
            return '<span>' + escapeHTML(w) + '</span>';
        }).join(' ');
    });
}
